module.exports = __webpack_public_path__ + "img/logo_neteco.3aa6dc68.svg";